import styled from 'styled-components';

export const IconButton = styled.button`
  background-color: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  padding: 0;
  min-width: 40px;
  height: 40px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 100ms ease-in-out;


  &:hover {
    background: ${({ theme }) => theme.colors.accentGray01};
  }

  &:active {
    background: ${({ theme }) => theme.colors.accentGray02};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.accentGray01};
  }

  &:disabled {
    background: none;
    cursor: not-allowed;
    fill: ${({ theme }) => theme.colors.ui03};
  }
`;
